import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Drawer } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { useParams } from "react-router";
import _ from "lodash";
import CorporateLayout from "../Layout";
import AddCorporate from "../AddCorporate";

import CorporateHeader from "../Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_CORPORATE_INFO } from "../../../redux/auth/authType";

const CorporateDetails = (): ReactElement => {
  const [singleCorporateInfo, setSingleCorporateInfo] = useState({
    loading: false,
    data: null,
  });
  const [selectedCorporateForEdit, setSelectedCorporateForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(false);
  const route = useParams();
  const dispatch = useDispatch();

  const fetchCorporateDetails = useCallback((getCorporateId) => {
    if (getCorporateId) {
      try {
        setSingleCorporateInfo({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_RIDER_API}/company/details?companyId=${getCorporateId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setSingleCorporateInfo({
                loading: false,
                data: data?.data?.company,
              });
              dispatch({
                type: SET_CORPORATE_INFO,
                payload: {
                  corporateInfo: {
                    id: data?.data?.company?.id,
                    ownerId: data?.data?.company?.ownerId,
                    name: data?.data?.company?.name,
                    image: data?.data?.company?.image,
                    balance: data?.data?.company?.balance,
                    isActive: data?.data?.company?.isActive,
                  },
                },
              });
            } else {
              setSingleCorporateInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleCorporateInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleCorporateInfo({ loading: false, data: null });
        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchCorporateDetails((route as any)?.corporateId);
  }, [fetchCorporateDetails, route]);

  const onClose = () => {
    setSelectedCorporateForEdit(null);
    fetchCorporateDetails((route as any)?.corporateId);
  };

  const corporate = singleCorporateInfo?.data;

  return (
    <React.Fragment>
      <CorporateLayout corporateId={(route as any)?.corporateId as string}>
        <div className="bg-white">
          <CorporateHeader
            leftarea={"Corporate Details"}
            rightarea={
              <Button
                type="primary"
                onClick={() => setSelectedCorporateForEdit(corporate?.id)}
                danger
              >
                <EditOutlined /> Edit
              </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Corporate Name</span>
                  <span className="info-desc">{corporate?.name}</span>
                </div>

                <div className="single">
                  <span className="info-name">ID</span>
                  <span className="info-desc">{corporate?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Industry</span>
                  <span className="info-desc">{corporate?.industry}</span>
                </div>

                {corporate?.numberOfEmployee ? (
                  <div className="single">
                    <span className="info-name">Number Of Employee</span>
                    <span className="info-desc ">
                      {corporate?.numberOfEmployee}
                    </span>
                  </div>
                ) : undefined}

                <div className="single">
                  <span className="info-name">Type</span>
                  <span className="info-desc">
                    {corporate?.type?.replace("_", " ")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">City</span>
                  <span className="info-desc">{corporate?.city}</span>
                </div>

                <div className="single">
                  <span className="info-name">Address</span>
                  <span className="info-desc">{corporate?.address}</span>
                </div>

                <div className="single">
                  <span className="info-name">Street</span>
                  <span className="info-desc">{corporate?.street}</span>
                </div>

                <div className="single">
                  <span className="info-name">ownerId</span>
                  <span className="info-desc">{corporate?.ownerId}</span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn text-uppercase ${
                        corporate?.isActive === true ? "active" : "inactive"
                      }-btn`}
                    >
                      {corporate?.isActive === true ? (
                        <>
                          <CheckOutlined className="mr-1" /> Active
                        </>
                      ) : (
                        <>
                          {" "}
                          <CloseOutlined className="mr-1" /> Inactive
                        </>
                      )}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Reason For Choosing</span>
                  <span className="info-desc">
                    {corporate?.reasonForChoosing}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Spokesman Name</span>
                  <span className="info-desc">{corporate?.spokesmanName}</span>
                </div>

                <div className="single">
                  <span className="info-name">Spokesman Email</span>
                  <span className="info-desc">{corporate?.spokesmanEmail}</span>
                </div>

                <div className="single">
                  <span className="info-name">Spokesman Mobile Number</span>
                  <span className="info-desc">
                    {corporate?.spokesmanMobileNumber?.split("+88")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Created Date</span>
                  <span className="info-desc">
                    {moment(corporate?.createdAt).format("lll")}
                  </span>
                </div>

                {visible ? (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(false);
                    }}
                  />
                ) : (
                  <QuestionCircleOutlined
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}

                {visible && (
                  <div className="">
                    <h6 className="mt-5 title" style={{ width: "98%" }}>
                      Activity Logs
                    </h6>
                    <div className="inner-body">
                      <div className="single">
                        <span className="info-name">Created Date</span>
                        <span className="info-desc">
                          {moment(corporate?.createdAt).format("lll")}
                        </span>
                      </div>

                      {corporate?.createdBy?.name ? (
                        <div className="single">
                          <span className="info-name">Created By</span>
                          <span className="info-desc">
                            {corporate?.createdBy?.name}
                          </span>
                        </div>
                      ) : undefined}

                      <div className="single">
                        <span className="info-name">Contact</span>
                        <span className="info-desc">
                          {corporate?.createdBy?.mobileNumber ||
                            corporate?.createdBy?.email}
                        </span>
                      </div>
                    </div>
                    {corporate?.updatedAt ? (
                      <div className="inner-body mt-4">
                        <div className="single">
                          <span className="info-name">Updated Date</span>
                          <span className="info-desc">
                            {moment(corporate?.updatedAt).format("lll")}
                          </span>
                        </div>

                        {corporate?.updatedBy?.name ? (
                          <div className="single">
                            <span className="info-name">Updated By</span>
                            <span className="info-desc">
                              {corporate?.updatedBy?.name}
                            </span>
                          </div>
                        ) : undefined}

                        {corporate?.updatedBy?.mobileNumber ? (
                          <div className="single">
                            <span className="info-name">Contact</span>
                            <span className="info-desc">
                              {corporate?.updatedBy?.mobileNumber ||
                                corporate?.updatedBy?.email}
                            </span>
                          </div>
                        ) : undefined}
                      </div>
                    ) : undefined}
                  </div>
                )}
              </div>
            </div>
          </div>

          <Drawer
            title={selectedCorporateForEdit ? "Edit Company" : ""}
            width={600}
            onClose={() => {
              setSelectedCorporateForEdit(null);
            }}
            visible={selectedCorporateForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedCorporateForEdit ? (
              <AddCorporate
                visibleData={selectedCorporateForEdit}
                onCloseMethod={onClose}
              />
            ) : undefined}
          </Drawer>
        </div>
      </CorporateLayout>
    </React.Fragment>
  );
};
CorporateDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default CorporateDetails;
